import { AutoLockFormsLevelType, FormNames } from '../autoLockForms.constants';

const formFields = [
  {
    name: 'taskCategoryOption',
    label: 'Task Category',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'taskTypeOption',
    label: 'Task Type',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'entity',
    label: 'Entity',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'formVariant',
    label: 'Form Type',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'state',
    label: 'State',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'formId',
    label: 'Form',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'borrower',
    label: 'Assignee',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'description',
    label: 'Description',
    levelType: AutoLockFormsLevelType.FIELD,
  },
];

export const assignTaskForm = {
  name: FormNames.ASSIGN_TASK,
  label: 'Assign Task',
  levelType: AutoLockFormsLevelType.FORM,
  children: formFields,
};
